import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) =>
  "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const resolveImg = (url) => {
  if (!url) return "";
  // Already a full URL (http/https) — use as-is
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  // Relative path starting with /api/ — prepend backend URL
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  // Any other relative path — prepend backend URL
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const WHATSAPP = "919599272633";
export const INSTAGRAM = "https://instagram.com/aetheldecor";
export const LOGO_URL = "/logo.png";

export default api;
